import {Component, inject, ViewChild} from '@angular/core';
import {FormlyFieldConfig, FormlyModule} from '@ngx-formly/core';
import {MatButtonModule} from '@angular/material/button';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {FormlyMatToggleModule} from '@ngx-formly/material/toggle';
import {ModuleListComponent} from './module-list/module-list.component';
import {cloneDeep} from 'lodash-es';
import {LicenseInterface} from '../interfaces/license.interface';
import {LicenseService} from '../services/license.service';
import {v4 as uuid} from 'uuid';
import {OrganizationService} from "../services/organization.service";
import {OrganizationInterface} from "../interfaces/organization.interface";
import {TariffService} from '../services/tariff.service';
import {TariffInterface} from '../tariffs/tariff.interface';

@Component({
  selector: 'app-license-registration',
  standalone: true,
  imports: [
    FormlyModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormlyMatToggleModule,
    ModuleListComponent
  ],
  templateUrl: './license-registration.component.html',
  styleUrl: './license-registration.component.scss'
})
export class LicenseRegistrationComponent {

  @ViewChild(ModuleListComponent, {static: true}) moduleListComponent?: ModuleListComponent;

  licenseService = inject(LicenseService);
  tariffService = inject(TariffService);
  modules: { module_key: string, description: string }[] = [];

  form = new FormGroup({});
  model: { license_key: string, Title: string  } | any = {};

  fields: FormlyFieldConfig[] = [];
  options: { label: string, value: { Title: string, value: number, ipAddress: string } }[] = [];
  tariffOptions: { label: string, value: number }[] = [];
  organizations: OrganizationInterface[] = [];

  constructor(public organizationService: OrganizationService) {
    this.loadOrganizationList();
    this.loadTariffList();
  }


  loadOrganizationList() {
    this.organizationService.loadOrganizationList()
      .subscribe((res: OrganizationInterface[]) => {
        this.organizations = res;
        this.options = res.map(item =>  {
          return {label: item.name, value: {Title: item.name, value: item.id, ipAddress: item.ipAddress}}
        });
        this.drawFields();
      })
  }

  loadTariffList() {
    this.tariffService.getTariffs()
      .subscribe((res: TariffInterface[]) => {
        this.tariffOptions = res.map(item => ({ label: item.name, value: item.id! }));
        this.drawFields();
      });
  }

  drawFields(){
    this.fields = [
      {
        key: 'organization',
        type: 'select',
        props: {
          label: $localize`:@@organization:Organization`,
          placeholder: $localize`:@@select-organization:Select Organization`,
          required: true,
          options: this.options,
          change: (field: any, $event: any) => {
            if ($event && $event?.value?.ipAddress) {
              // Update API_REST_URL field with selected organization's ipAddress
              const apiRestUrlField = this.fields.find(f => f.key === 'API_REST_URL');
              if (apiRestUrlField) {
                this.model.API_REST_URL = $event?.value?.ipAddress;
                this.form.patchValue({API_REST_URL: $event?.value?.ipAddress});
              }
            }
          }
        }
      },
      {
        key: 'tariffId',
        type: 'select',
        props: {
          label: 'Tariff',
          placeholder: 'Select tariff',
          required: true,
          options: this.tariffOptions
        }
      },
      {
        key: 'license_key',
        type: 'input',
        defaultValue: uuid(),
        props: {
          label: $localize`:@@license:License`,
          placeholder: $localize`:@@enter-license-key:Enter license key`,
          required: true,
        }
      },
      {
        key: 'baseHref',
        type: 'input',
        defaultValue: '/',
        props: {
          label: $localize`:@@base-href:baseHref`,
          placeholder: $localize`:@@enter-base-href:Enter baseHref`,
          required: true,
        }
      },

      {
        key: 'production',
        type: 'toggle',
        defaultValue: true,
        props: {
          label: $localize`:@@production:Production`,
        }
      },

      {
        key: 'environment',
        type: 'select',
        defaultValue: 'PROD',
        props: {
          label: $localize`:@@environment:Environment`,
          placeholder: $localize`:@@select-environment:Select environment`,
          required: true,
          options: [
            {value: 'PROD', label: 'PROD'},
            {value: 'DEV', label: 'DEV'},
          ]
        }
      },
      {
        key: 'API_REST_URL',
        type: 'input',
        defaultValue: 'http://127.0.0.1',
        props: {
          label: $localize`:@@api-rest-url:API_REST_URL`,
          placeholder: $localize`:@@enter-api-rest-url:Enter API_REST_URL`,
          required: true,
        }
      },

      {
        key: 'API_REST_PORT',
        type: 'input',
        defaultValue: '3000',
        props: {
          label: $localize`:@@api-rest-port:API_REST_PORT`,
          placeholder: $localize`:@@enter-api-rest-port:Enter API_REST_PORT`,
          required: true,
        }
      },

      {
        key: 'API_REGISTER_SERVER',
        type: 'input',
        defaultValue: 'https://kreditpro.org',
        props: {
          label: $localize`:@@api-register-server:API_REGISTER_SERVER`,
          placeholder: $localize`:@@enter-api-register-server:Enter API_REGISTER_SERVER`,
          required: true,
        }
      },
    ];
  }

  save(model: any) {
    console.log('model', model);
    console.log('this.modules', this.modules)
    const environment = {...model};
    delete environment.license_key;
    delete environment.tariffId;
    const license_key = model.license_key;
    environment.Title = model.organization.Title

    const license: LicenseInterface = {
      environment,
      license_key,
      module_list: this.modules,
      tariffId: model.tariffId,
    } as LicenseInterface;

    this.licenseService.registerLicense(license)
      .subscribe((res) => {
        this.moduleListComponent?.init();
        this.model.license_key = uuid();
        this.model.Title = '';
        this.form.patchValue(this.model);
      })


  }

  moduleChange($event: { module_key: string, description: string }[]) {
    this.modules = cloneDeep($event);

  }
}
